import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isLoggedIn, isServiceProvider } from "../../utils/AuthService";
import Header from "../../components/layouts/Header";
import Footer from "../../components/layouts/Footer";
import Sidebar from "./Sidebar";
import useRoutePrefetch from "../../hooks/useRoutePrefetch";
import useRefinedRouteScrollReset from "../../hooks/useRefinedRouteScrollReset";
import { canUseRefinedAppUI } from "../../utils/featureFlags";
import { getRefinedUIRouteContext } from "../../utils/refinedUIRoutes";
import RefinedUIProvider from "../../components/generics/RefinedUIProvider";

const MarketLayout = () => {
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { pathname } = useLocation();
  const prefetchRootRef = useRoutePrefetch(pathname);
  const refinedUI = canUseRefinedAppUI(currentUser);
  useRefinedRouteScrollReset(pathname, refinedUI);
  if (!isLoggedIn()) {
    return <Navigate to="/login" />;
  }

  // Service providers should only access the provider portal
  if (isServiceProvider()) {
    return <Navigate to="/provider-portal" />;
  }

  const routeContext = getRefinedUIRouteContext(pathname);
  const refinedContentClass = refinedUI
    ? ` refined-ui-content ${routeContext.className}`
    : "";

  return (
    <RefinedUIProvider enabled={refinedUI}>
      <div ref={prefetchRootRef} className={`app${refinedUI ? " app--refined" : ""}`}>
        <Header refinedUI={refinedUI} />
        <div className="app-body">
          <Sidebar refinedUI={refinedUI} />
          <main className="main">
            <div className={`container-fluid mt-2${refinedContentClass}`}>
              <Outlet />
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </RefinedUIProvider>
  );
};

export default MarketLayout;
